<script setup lang="ts">
import { flattenEntity } from 'strapi-flatten-graphql'
import type { PlainImage } from '~/models/Strapi'

interface Props {
  datas: any
}

const props = defineProps<Props>()
const flattenData = ref<PlainImage>({ ...props.datas, image: flattenEntity(props.datas?.image?.data) })
</script>

<template>
  <div>
    <h2 v-if="flattenData?.title" class="text-2xl font-bold mb-4">
      {{ flattenData?.title }}
    </h2>
    <div v-if="flattenData?.content">
      <div v-for="(item, idx) in flattenData?.content" :key="idx" v-html="useArticleHTMLSerializer(item)" />
    </div>
    <NuxtLink :to="flattenData?.url" target="_blank">
      <img :src="flattenData?.image?.url" class="aspect-video object-cover w-full">
    </NuxtLink>
    <p v-if="flattenData?.image_description" class="text-[10px] text-gray-500 mt-1 text-center">
      {{ flattenData?.image_description }}
    </p>
  </div>
</template>
